const vendor = {
  modal: {
    editVendor: 'Редактировать запись',
    exportVendor: 'Экспорт',
    storeVendor: 'Добавить новую запись',
    share: 'Поделиться',
    store: 'Магазин',
    vendor: 'Поставщик',
    country: 'Страна',
    mature: 'Зрелый',
    products: 'Товары',
    successUpdate: 'Существующая запись успешно обновлена',
    successStore: 'Новая запись успешно добавлена',
    exportVendorsLoading: 'Загрузка экспортируемых поставщиков...',
  },
  page: {
    adminVendors: 'Поставщики администратора',
    adminVendorsOptions: 'Параметры поставщиков администратора',
    showing: 'показывается',
    vendorsOf: 'поставщики из',
    noVendorsFound: 'Поставщики не найдены',
  },
  tableDropdown: {
    quickActions: 'Быстрые действия',
    refresh: 'Обновить',
    exportVendors: 'Экспорт',
    prepareExportVendors: 'Подготовка экспорта',
  },
  actionsDropdown: {
    edit: 'Редактировать',
    delete: 'Удалить',
  },
  messages: {
    vendorDeleted: 'Поставщик успешно удален',
    vendorUpdated: 'Поставщик успешно обновлен',
  }
};

export default vendor;
